import { Link } from "react-router-dom";

function PageNotFound() {
  return (
    <>
      <h1>No es la página que buscabas</h1>
      <Link to="/" replace>
        Ir al inicio
      </Link>
    </>
  );
}

export default PageNotFound;
